"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareDates = compareDates;
exports.requestStatus = requestStatus;
exports.rehydrateStatus = rehydrateStatus;
exports.rehydrateReducer = rehydrateReducer;
exports.rehydrateEmpty = exports.toCamelCaseString = exports.toCamelCaseKeys = exports.toUnderscoreString = exports.toUnderscoreKeys = void 0;

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _statusEnum = _interopRequireDefault(require("../enums/statusEnum"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function transformString(_ref) {
  var value = _ref.value,
      method = _ref.method;

  if (!(0, _lodash.isString)(value)) {
    return value;
  }

  if (method === "underscore") {
    return value.replace(/([a-z][A-Z]|[a-z][0-9])/g, function (match) {
      return "".concat(match[0], "_").concat(match[1].toLocaleLowerCase());
    });
  }

  return value.replace(/_([a-z]|[A-Z]|[0-9])/g, function (match) {
    return match[1].toUpperCase();
  });
}
/* Input value is an object with possibly nested objects */


function transformKeys(_ref2) {
  var value = _ref2.value,
      method = _ref2.method;

  if ((0, _lodash.isPlainObject)(value)) {
    return (0, _lodash.chain)(value).mapKeys(function (val, key) {
      return transformString({
        value: key,
        method: method
      });
    }).mapValues(function (val) {
      return transformKeys({
        value: val,
        method: method
      });
    }).value();
  }

  if ((0, _lodash.isArray)(value)) {
    return value.map(function (obj) {
      return transformKeys({
        value: obj,
        method: method
      });
    });
  }

  return value;
}

var toUnderscoreKeys = function toUnderscoreKeys(obj) {
  return transformKeys({
    value: obj,
    method: "underscore"
  });
};

exports.toUnderscoreKeys = toUnderscoreKeys;

var toUnderscoreString = function toUnderscoreString(value) {
  return transformString({
    value: value,
    method: "underscore"
  });
};

exports.toUnderscoreString = toUnderscoreString;

var toCamelCaseKeys = function toCamelCaseKeys(obj) {
  return transformKeys({
    value: obj,
    method: "camelCase"
  });
};

exports.toCamelCaseKeys = toCamelCaseKeys;

var toCamelCaseString = function toCamelCaseString(value) {
  return transformString({
    value: value,
    method: "camelCase"
  });
};

exports.toCamelCaseString = toCamelCaseString;

function compareDates(dateA, dateB) {
  var dateAMoment = (0, _moment["default"])(dateA);
  var dateBMoment = (0, _moment["default"])(dateB);
  if (dateAMoment.isBefore(dateBMoment)) return -1;
  if (dateAMoment.isAfter(dateBMoment)) return 1;
  return 0;
}

function requestStatus(currentStatus) {
  if ([_statusEnum["default"].SUCCESS, _statusEnum["default"].RELOADING].includes(currentStatus) === false) {
    return _statusEnum["default"].REQUESTED;
  }

  return _statusEnum["default"].RELOADING;
}

function rehydrateStatusHelper(currentStatus, incomingStatus) {
  if (currentStatus === _statusEnum["default"].INITIAL) {
    return incomingStatus;
  }

  if (currentStatus === _statusEnum["default"].REQUESTED) {
    if ([_statusEnum["default"].SUCCESS, _statusEnum["default"].RELOADING].includes(incomingStatus)) {
      return _statusEnum["default"].RELOADING;
    }

    return _statusEnum["default"].REQUESTED;
  }

  return currentStatus;
}

function rehydrateStatus(whitelist, state, incoming) {
  var newState = _objectSpread({}, state);

  whitelist.map(function (propertyName) {
    newState.status[propertyName] = rehydrateStatusHelper(state.status[propertyName], incoming.status[propertyName]);
    return propertyName;
  });
  return newState;
}

function rehydrateReducer(whitelist, state, incoming) {
  var newState = _objectSpread({}, state);

  whitelist.map(function (propertyName) {
    newState[propertyName] = incoming[propertyName];
    return propertyName;
  });
  return newState;
}

var rehydrateEmpty = function rehydrateEmpty(state, incoming) {
  return Object.keys(state).length ? state : incoming;
};

exports.rehydrateEmpty = rehydrateEmpty;